import copy from 'copy-to-clipboard';
import type { CombinedError } from 'urql';

import {
  DELIVERABLES_NAME_NOT_UNIQUE,
  DELIVERABLES_REPORT_EXISTS,
  ENTITY_NOT_FOUND,
  isTooManyEntitiesError,
} from '@revelio/data-access';
import { RevelioTooltip } from '@revelio/ui';

import { TOO_MANY_CHART_ENTITIES_ERROR_MESSAGE } from '../../../next/CustomDash/filters/constants/filter-constants';
import styles from './urql-and-tanstack-error-message.module.css';

export const DEFAULT_ERROR_MSG = `We've run into an error and our team has been alerted. Please try again later.`;

const errorMessageDisplayTextLookup: Record<string, string> = {
  [ENTITY_NOT_FOUND]: `Currently the data for the selected Entity(ies) does not exist in our Dashboard. Feel free to reach out to your Revelio Labs contact for more information.`,
  [DELIVERABLES_NAME_NOT_UNIQUE]:
    'This deliverable name already exists. Please enter a unique name to continue.',
  [DELIVERABLES_REPORT_EXISTS]:
    'This report name already exists. Please enter a unique name to continue.',
};

export const getErrorMessageToDisplay = (errorMessage: string) => {
  if (isTooManyEntitiesError(errorMessage)) {
    return TOO_MANY_CHART_ENTITIES_ERROR_MESSAGE;
  }

  const matchedKey = Object.keys(errorMessageDisplayTextLookup).find((key) =>
    errorMessage.includes(key)
  );

  if (matchedKey) {
    return errorMessageDisplayTextLookup[matchedKey];
  }

  return DEFAULT_ERROR_MSG;
};

export const UrqlAndTanstackErrorMessage = ({
  error,
  reqId,
}: {
  error: CombinedError | Error;
  reqId: string | undefined;
}) => {
  const message = getErrorMessageToDisplay(error.message);

  return (
    <>
      <div className={styles.message}>{message}</div>
      {reqId ? (
        <RevelioTooltip label="Copy to clipboard" placement="top">
          <div
            className={styles.requestId}
            onClick={() => copy(`req-id: ${reqId}`)}
          >
            {reqId}
          </div>
        </RevelioTooltip>
      ) : (
        <span></span>
      )}
    </>
  );
};
